import oCEANIC from '../../assets/oCEANIC.png'
import Wabash from '../../assets/logos/wabash.jpg'
import AmazonWholeFoods from '../../assets/logos/amazon.png'
import FinishLine from '../../assets/logos/jd.png'
import Google from '../../assets/logos/google.png'
import Microsoft from '../../assets/logos/microsoft.png'

export const internships = [
    {
      image: Google,
      title: "Software Engineer Intern",
      href: "https://labs.google.com/search/",
      linkPreview: "labs.google.com/search/",
      description:
        "AI Mode @ Google Search",
      tags: ["Java, Swift"]
    },
    {
      image: Microsoft,
      title: "Data Scientist Intern",
      href: "https://microsoft.ai/",
      linkPreview: "microsoft.ai",
      description: 
        "Agentic AI @ MAI",
      tags: ["Python, Databricks, Claude, ChatGPT, DeepSeek"]
    },
    {
        image: Wabash,
        title: "Project Management Intern",
        href: "https://onewabash.com/",
        linkPreview: "onewabash.com",
        description:
          "Leading a team of 16 through the development of a user-facing chatbot.",
        tags: ["Azure DevOps", "Azure AI", "OpenAI"],
    },
    {
      image: AmazonWholeFoods,
      title: "Data Science Intern",
      href: "https://www.amazon.com/alm/storefront?almBrandId=VUZHIFdob2xlIEZvb2Rz",
      linkPreview: "amazon.com",
      description:
        "Data Science intern at Amazon under the world-wide grocery sector. ",
      tags: ["AWS Redshift", "AWS S3", "SQL", "Python"],
    },
    {
      image: oCEANIC,
      title: "Software Engineer Intern",
      href: "https://projectoceanic.substack.com/",
      linkPreview: "project-oceanic.com",
      description:
        "Developed a computational maritime model as part of a R&D internship in Hawai'i.",
      tags: ["NextJS", "Typescript", "Python", "ARCGis"],
    },
    {
      image: FinishLine,
      title: "Data Science Intern",
      href: "https://www.finishline.com/store/about-jd?srsltid=AfmBOooIEaq8qLM2zlqS0ZuOpw6DYkYcvEKf6zgk_s1qcEq6-fwH8e8e",
      linkPreview: "jdsports.com/",
      description:
        "Data Science Intern at JD Finish Line under the supply chain management team.",
      tags: ["Python", "Tensorflow", "Google Vertex AI"],
    },
    
    
];